// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1NjCB","menu_bar":"style_menu_bar__10xFo","content_box":"style_content_box__1vSWT","form":"style_form__1jANd"};